import { render, staticRenderFns } from "./proforma.vue?vue&type=template&id=1fee526f&scoped=true&"
import script from "./proforma.vue?vue&type=script&lang=js&"
export * from "./proforma.vue?vue&type=script&lang=js&"
import style0 from "./proforma.vue?vue&type=style&index=0&id=1fee526f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee526f",
  null
  
)

export default component.exports